export default "__VITE_ASSET__$ykVy43Q__"